angular.module('bmsApp.directives').factory('PhotoSvc', [
	'$q',
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'EMAIL_API', function (
		$q,
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		EMAIL_API) {

	return {
		showViewModal: function (title, photo) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/photo/templates/PhotoViewModal.html',
				controller: 'PhotoViewModalCtrl',
				size: 'md',
				scope: $rootScope,
				resolve: {
					photo: function () {
						return angular.copy(photo)
					},
					title: function () {
						return angular.copy(title)
					}
				}
			});
		},
	};

}]);
